export default __webpack_public_path__ + "static/banner6-8bc5a2f6f7af5045ef2bdee0541903a4.jpeg";